import { TranslationService } from '@core/services/translation.service';
import { ValueTypeEnum }      from '@models/common.model';

export {
	getValueByValueType
};


/**
 * Returns value by specified `valueType`.
 *
 * @param valueType - a return value "type" identifier (either `VALUE` or `I18N`)
 * @param value - either some random value (preferably a string or numeric value) or i18n translation path
 * @param spareValue - placeholder string
 * @param translationService - service for i18n
 *
 * @returns The input `value` itself if `valueType` is `VALUE`, or a string
 *          resulting from a lookup in the i18n maps if `valueType` is `I18N`.
 *          If input `value` is nullish or no matching string was found in the
 *          i18n maps, the spare string is returned.
 */
function getValueByValueType( valueType: ValueTypeEnum, value: any, spareValue: string = '-', translationService: TranslationService ): any {

	switch ( valueType ) {
		case ValueTypeEnum.I18N:
			return translationService.getI18nString( false, null, value, true, spareValue );
		case ValueTypeEnum.VALUE:
			return value ?? spareValue;
		default:
			return null;
	}
}
